export const TESTIDS = {
  // navigation
  navDashboard: "nav-dashboard",
  navTerminals: "nav-terminals",
  navVessels: "nav-vessels",
  navPortCalls: "nav-port-calls",
  navAssets: "nav-assets",
  navPersonnel: "nav-personnel",
  navSops: "nav-sops",
  navAudit: "nav-audit",
  navHelp: "nav-help",

  // dashboard
  dashboardKpi: "dashboard-kpi",
  conflictsBadge: "dashboard-conflicts-badge",

  // terminals
  terminalSelector: "terminal-selector",
  btnCreateTerminal: "btn-create-terminal",
  btnCreateBerth: "btn-create-berth",
  btnUploadMap: "btn-upload-map",
  inputMapFile: "input-map-file",
  btnAutoDetect: "btn-auto-detect-annotations",

  // Five-stage map pipeline
  pipelinePanel: "map-pipeline-panel",
  pipelineFileInput: "pipeline-file-input",
  pipelineSourceType: "pipeline-source-type",
  pipelineProcessBtn: "pipeline-process-btn",
  pipelineResultsBlock: "pipeline-results-block",
  pipelinePhaseRow: "pipeline-phase-row",
  pipelineStatusBadge: "pipeline-status-badge",

  // vessels
  btnCreateVessel: "btn-create-vessel",
  btnCreateShipAsset: "btn-create-ship-asset",

  // port calls
  btnCreatePortCall: "btn-create-port-call",
  btnSubmitPortCall: "btn-submit-port-call",
  btnApprovePortCall: "btn-approve-port-call",
  btnAiExplain: "btn-ai-explain",
  btnAiRecommend: "btn-ai-recommend",

  // assignments
  btnAssignAsset: "btn-assign-asset",
  btnAssignPersonnel: "btn-assign-personnel",

  // weather/tide
  btnRefreshConditions: "btn-refresh-conditions",
  btnManualConditions: "btn-manual-conditions",

  // assets
  btnCreateTerminalAsset: "btn-create-terminal-asset",
  btnCreatePersonnel: "btn-create-personnel",
  btnCreateSop: "btn-create-sop",
};

export default TESTIDS;
